import { Link } from 'react-router-dom'
import { Headphones, Facebook, Instagram, Mail, Award, Share2 } from 'lucide-react'

function Footer() {
  const footerLinks = {
    product: [
      { label: 'Podcasts', path: '/podcasts' },
      { label: 'Courses', path: '/courses' },
      { label: 'Ambassador Program', path: '/ambassador-program', icon: Award },
      { label: 'Dashboard', path: '/dashboard' }
    ],
    company: [
      { label: 'About Us', path: '#' },
      { label: 'Blog', path: '#' },
      { label: 'Careers', path: '#' },
      { label: 'Contact', path: '#' }
    ],
    legal: [
      { label: 'Privacy Policy', path: '#' },
      { label: 'Terms of Service', path: '#' },
      { label: 'Cookie Policy', path: '#' }
    ]
  }

  const socialLinks = [
    { icon: Facebook, url: 'https://web.facebook.com/profile.php?id=61584257703029', label: 'Facebook' },
    { icon: Instagram, url: 'https://www.instagram.com/saints__academy_', label: 'Instagram' },
    { icon: Share2, url: 'https://www.tiktok.com/@saints__academy_', label: 'TikTok' },
    { icon: Mail, url: 'mailto:sne@saintsacademy.co.za', label: 'Email' }
  ]

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-primary to-accent rounded-lg flex items-center justify-center">
                <Headphones className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-bold text-white">Saints Academy</span>
            </div>
            <p className="text-gray-400 mb-6 max-w-sm">
              AI-powered learning ecosystem combining podcast discovery with comprehensive online courses. Learn, grow, and level up your skills.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social) => {
                const Icon = social.icon
                return (
                  <a
                    key={social.label}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-primary transition-colors duration-200"
                  >
                    <Icon className="w-5 h-5" />
                  </a>
                )
              })}
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Product</h3>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.path}
                    className="text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.path}
                    className="text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2026 Saints Academy. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm">
              Powered by AI • Built with ❤️
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer